<template>
  <div style="height: 100%">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span style="color: #4a90e2">
            <i class="el-icon-location"></i>
            {{ $t('changepwd.首页') }}
          </span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('changepwd.修改密码') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="container" style="width: 100%; height: 90%">
      <div class="zl-content account">
        <div class="zl-form">
          <div class="form-item">
            <input type="text" v-model="unm" :placeholder="$t('changepwd.用户名')" />
          </div>
          <div class="form-item">
            <input type="password" v-model="pwd" :placeholder="$t('changepwd.旧密码')" />
          </div>
          <div class="form-item">
            <input type="password" v-model="newpwd" :placeholder="$t('changepwd.新密码')" />
          </div>
          <div class="form-item">
            <el-button class="zl-submit" :plain="true" @click="cfmchange">{{ $t('changepwd.确认修改') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../utils'
import { changepwd } from '../service/getData'
import { getUser } from '../utils/auth'
export default {
  name: 'app',
  mixins: [mixin],

  data() {
    return {
      unm: getUser(),
      pwd: null,
      newpwd: null,
    }
  },
  methods: {
    async cfmchange() {
      let result = await changepwd(this.unm, this.pwd, this.newpwd)
      let data = result.data
      if (data.ResultType == 0) {
        this.$message({
          message: data.Message,
          type: 'success',
        })
      } else {
        this.$message({
          message: data.Message,
          type: 'error',
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.zl-content {
  &.account {
    background: white;
    padding: 15px;
    .zl-form {
      width: 90%;
      margin: 0 auto;
      margin-top: 30px;
      text-align: center;
      .form-item {
        margin-bottom: 30px;
        input {
          border: 1px solid #f1f1f1;
          padding: 15px;
          width: 80%;
          &.inputValidat {
            width: 40%;
          }
        }
        button {
          border: 1px solid #f1f1f1;
          padding: 15px;
          width: 39%;
          background: rgba(0, 0, 0, 0.1);
        }
        .zl-submit {
          /* Rectangle 2: */
          background: #126c99;
          border-radius: 4px;
          color: white;
          width: 280px;
        }
      }
    }
  }
}
</style>
